import { Component, effect, EventEmitter, Input, OnChanges, Output, Signal, SimpleChanges } from '@angular/core';
import { Mod, ModItemCategory, ModTierItemVm, TieredMod } from '../../../models/item-data-models';
import { BaseComponent } from '../../base.component';
import { ItemDataService } from '../../../services/item-data.service';
import { ModTierService } from '../../../services/tiering/mod-tier.service';
import { ModDomain } from '../../../models/enums';
import { ModListComponent, ModListConfig } from './mod-list/mod-list.component';

interface SiblingModVm {
  id: number;
  name: string;
  text: string;
  lvl: number;

  defaultTier?: number;
  specificTier?: number;
}

@Component({
  selector: 'app-multi-mod-label',
  templateUrl: './multi-mod-label.component.html',
  styleUrls: ['../../../tier-list-tab/tier-tab-common.scss', '../../label-common.scss', '../mod-label.component.scss', 'multi-mod-label.component.scss'],
  standalone: true,
  imports: [ModListComponent]
})
export class MultiModLabelComponent extends BaseComponent {
  @Input({ required: true }) mod!: ModTierItemVm;
  @Input() domain?: ModDomain;
  @Input() hideTooltip?: boolean;
  @Input() displayText?: string;
  @Input() itemCategory?: ModItemCategory;
  @Input() possiblyIncorrectSlot?: boolean;
  @Input() noApplicableTag?: boolean;

  @Output() resetToOriginalTier = new EventEmitter<ModTierItemVm>();

  defaultTier?: number;
  specificTier?: number;
  specificTierSlot?: string;
  siblingMods: SiblingModVm[] = [];

  showTooltip = false;
  highlightedText?: string;

  modDomainMap = {
    [ModDomain.AbyssJewel]: 'Abyss Jewels',
    [ModDomain.TimeLostJewel]: 'Time-Lost Jewels',
    [ModDomain.ClusterJewel]: 'Cluster Jewels',
    [ModDomain.Jewel]: 'Jewels',
    [ModDomain.Equipment]: 'Equipment'
  };

  onMouseEnter() {
    if (this.mod.primaryMod?.text) {
      this.highlightedText = this.highlightValues(this.mod.primaryMod.text);
    }

    this.showTooltip = true;
  }

  onMouseLeave() {
    this.showTooltip = false;
  }

  highlightValues(effect: string, alwaysHighlight = false) {
    if (!this.settings.highlightStats() && !alwaysHighlight) {
      return effect;
    }
    // Avoid double processing if already highlighted
    if (effect.includes('<span class="it-effect-value">')) {
      return effect;
    }
    return effect.replace(/([\+\-]\(\d+(\.\d+)?-\d+(\.\d+)?\)|\(\+?-?\d+(\.\d+)?-\d+(\.\d+)?\)|\+?-?\d+(\.\d+)?)/g, '<span class="it-effect-value">$&</span>');
  }
}
